var _Pre_container, _Pre_clock;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
export class Pre {
    constructor(container, clock) {
        _Pre_container.set(this, void 0);
        _Pre_clock.set(this, void 0);
        /**
         * Inject a context into current editor.
         *
         * @param ctx - The context needs to be injected.
         * @param defaultValue - The default value of this context.
         * @returns Pre.
         */
        this.inject = (ctx, defaultValue) => {
            ctx(__classPrivateFieldGet(this, _Pre_container, "f").sliceMap, defaultValue);
            return this;
        };
        /**
         * Start to record for a timer.
         *
         * @param timer - The timer needs to be recorded.
         * @returns Pre.
         */
        this.record = (timer) => {
            timer(__classPrivateFieldGet(this, _Pre_clock, "f").store);
            return this;
        };
        __classPrivateFieldSet(this, _Pre_container, container, "f");
        __classPrivateFieldSet(this, _Pre_clock, clock, "f");
    }
}
_Pre_container = new WeakMap(), _Pre_clock = new WeakMap();
//# sourceMappingURL=pre.js.map